export enum TenantFeatureSettingWorkFlowType {
    BankAccountChangeEntityFramework = 6,
    CaptureMailboxesCreation = 23,
    CashDiscCodeChangeEntityFramework = 12,
    CodingPrediction = 7,
    D365RoleDooapRequiredToAccessDooap = 10,
    DatabaseAlertRuleCreation = 22,
    DocumentsTransfer = 5,
    EnableSftp = 20,
    FixedAssetPostingProfilesChangeEntityFramework = 27,
    FixedAssetsChangeEntityFramework = 26,
    KeyVaultAppRegistrationSecretRotation = 16,
    MainDimensionChangeEntityFramework = 17,
    MiscChargeChangeEntityFramework = 13,
    PaymentInformationChangeEntityFramework = 4,
    PaymentTermChangeEntityFramework = 11,
    PowerBiWorkspaceDeployment = 21,
    ProductReceiptChangeEntityFramework = 3,
    ProjectActivitiesChangeEntityFramework = 14,
    ProjectDefaultLinePropertiesChangeEntityFramework = 18,
    ProjectLinePropertiesChangeEntityFramework = 19,
    PurchaseAgreementHeadersChangeEntityFramework = 28,
    PurchaseAgreementLinesChangeEntityFramework = 29,
    PurchaseOrderChangeEntityFramework = 2,
    SalesTaxChangeEntityFramework = 15,
    SalesTaxPrediction = 8,
    SearchServiceSelection = 24,
    SimilarityVendorRecognition = 25,
    VendorChangeEntityFramework = 1,
    WorkflowPrediction = 9,
}

export enum WorkflowModalType {
    Feature = 0,
    TenantDeletion = 1,
}

export enum WorkflowStepStatus {
    Pending,
    InProcess,
    Completed,
    Failed,
    CompletedWithError,
}

export enum WorkflowStatus {
    NotStarted,
    Running,
    Failed,
    Success,
    Pending,
    Terminated,
    WaitForApprove,
}

export enum FailoverType {
    Retry = 0,
    Skip = 1,
}

export interface IWorkflowBase {
    id: string;
    tenantId: string;
    status: WorkflowStatus;
    steps: IWorkflowStepBase[];
}

export interface ITenantFeatureSettingWorkFlow extends IWorkflowBase {
    featureName: string;
    type: TenantFeatureSettingWorkFlowType;
    toggleValue: number;
    userName: string;
    data: any | null;
}

export interface ITenantDeleteWorkflow extends IWorkflowBase {
    dooapEnvironmentId: string;
    userName: string;
}

export interface IFailedStepHandle {
    failoverType: FailoverType;
}

export enum EnvironmentStatus {
    Normal = 0,
    Warning,
    Error,
}

export interface IWorkflowStepBase {
    id: string;
    actionDescription: string;
    order: number;
    status: WorkflowStepStatus;
    logs: string | null;
    errorMessage: string | null;
    processDateTime: Date | null;
}
export interface ITenantFeatureSettingStep extends IWorkflowStepBase {
    tenantFeatureSettingWorkFlowId: string;
}

export interface ITenantDeleteWorkflowStep extends IWorkflowStepBase {
    deleteWorkflowId: string;
}

export interface TenantFeatureSettingWorkFlowToggleValue {
    settingName: string;
    toggleValue: boolean;

    data: any | null;
}

export interface ChangeEntityFrameworkSettingToggleValue {
    settingName: string;
    settingToggleValue: boolean;
    axImportToggleValue: boolean;
}

export enum ToggleValueType {
    None = 0,
    Setting = 1 << 0,
    AxImport = 1 << 1,
}

export const mlTenantFeatureSettingTypes = [
    TenantFeatureSettingWorkFlowType.WorkflowPrediction,
    TenantFeatureSettingWorkFlowType.SalesTaxPrediction,
    TenantFeatureSettingWorkFlowType.CodingPrediction,
];
